import React from 'react'
import styled from 'styled-components'

import { ImageLogConfig } from '../../../types/image-log'
import ConfigForm from './ConfigForm'

type DashboardActionsProps = {
    changeConfig: (field: string, value: unknown) => void
    widgetConfig: LiveWidgetConfig<ImageLogConfig>
}

const DashboardActions = ({ changeConfig, widgetConfig, ...props }: DashboardActionsProps): React.ReactElement => {
    return (
        <DashboardActionsContainer>
            <ConfigForm
                changeConfig={changeConfig}
                changeLayoutConfig={changeConfig}
                widgetConfig={widgetConfig}
                isEditor={false}
            />
        </DashboardActionsContainer>
    )
}

const DashboardActionsContainer = styled.div`
    .Select-control {
        background-color: var(--static-gray-800);
        color: var(--static-gray-100);
        border-color: var(--static-gray-900);

        .Select-value {
            background-color: var(--static-gray-800);

            .Select-value-label {
                > div {
                    color: var(--static-gray-100);
                }
            }
        }

        .Select-placeholder {
            background-color: var(--static-gray-800);
        }
    }

    .Select-menu-outer {
        border-color: var(--static-gray-100);

        .Select-option {
            background-color: var(--static-gray-800);
            color: var(--static-gray-100);

            &.is-focused {
                background-color: var(--static-gray-900);
            }
        }
    }

    .input-field {
        > input {
            color: var(--static-gray-100);
            border-color: var(--static-gray-600);
        }

        > input,
        div {
            background-color: var(--static-gray-800);
        }
    }
`

export default DashboardActions
